import currencies from '../maps/currencies'

export default function currency (value, precision, currency) {

    let symbol = currency ? currencies[currency.toUpperCase()] : currencies.EUR

    if (precision > 0) {

        let parsed = parseFloat(value)

        if (isNaN(parsed)) {
            return value
        }

        let formatted = parsed.toFixed(precision).replace('.', ',')
        return formatted.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.') + ' ' + symbol

    } else {

        return parseFloat(value).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.') + ' ' + symbol
    }

}


// WEBPACK FOOTER //
// ./src/formatters/currency.js